<div class="PageHeader">
    <div class="PageHeader__TitleSection">
        @if (showBackButton) {
            <button mat-icon-button class="PageHeader__BackButton" (click)="onBackClick()">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }
        <h1 class="PageHeader__Title">{{ title }}</h1>
    </div>
    <div class="PageHeader__Actions">
        <ng-content></ng-content>
    </div>
</div>
